var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.995 29.014L24.712 7.301a.894.894 0 00-.89-.8h-4.29v-.977C19.531 2.478 17.05 0 14 0S8.47 2.478 8.47 5.524V6.5H4.177a.894.894 0 00-.889.8L1.005 29.014a.894.894 0 00.89.986h24.21a.895.895 0 00.89-.986zM10.257 5.524A3.745 3.745 0 0114 1.786a3.745 3.745 0 013.743 3.738V6.5h-7.486v-.977zm-7.37 22.69L4.982 8.287H8.47v1.967a.894.894 0 001.788 0V8.287h7.486v1.967a.894.894 0 001.788 0V8.287h3.487l2.095 19.927H2.887z","fill":"#FFF","fillRule":"nonzero"}));
}

Cart.defaultProps = {"viewBox":"0 0 28 30"};

module.exports = Cart;

Cart.default = Cart;
